import type {ReactElement} from 'react';
import React from 'react';
import {ItemBaseLineHeightOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-base-line-height-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromTextStylesOfSelectedTextSlideItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesOfSelectedTextSlideItem';

export function TextSlideLineHeightOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const leading = useGetKeyFromTextStylesOfSelectedTextSlideItem('leading');

  if (!activeItem?.isSlideshow()) {
    throw new Error(`Expected slideshow item but got ${activeItem?.gitype}`);
  }

  if (!activeSlideUID) {
    throw new Error('unable to get the selected text slide');
  }

  if (leading === undefined) {
    throw new Error('unable to get leading for text slide item');
  }

  const updateLeadingValue = (leading: number, undoable = true): void => {
    void activeItem.updateSlideFromObject(
      activeSlideUID,
      {
        textStyles: {
          leading,
        },
      },
      {
        undoable,
      }
    );
  };

  return <ItemBaseLineHeightOption onUpdateLeadingValue={updateLeadingValue} leading={leading} />;
}
